import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      display: "flex",
    },
    vector: {
      height: ({
        isAdvancedSettingsBarOpen,
      }: {
        isAdvancedSettingsBarOpen: boolean;
      }) => (isAdvancedSettingsBarOpen ? "60px" : "41px"),
      width: "20px",
      borderLeft: `1.5px dashed ${theme.gray200}`,
      borderBottom: `1.5px dashed ${theme.gray200}`,
    },
    advancedSettingsContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(6),
      margin: theme.spacing(0, 6, 5, 0),
      padding: theme.spacing(6, 8),
      borderRadius: "12px",
      backgroundColor: theme.gray50,
    },
    flexWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: theme.spacing(5),
    },
    typo500: {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "24px",
      color: theme.gray800,
    },
    typo400: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
      color: theme.gray500,
    },
    arrowIcon: {
      width: "21px",
      height: "21px",
      color: theme.gray500,
      transform: ({
        isAdvancedSettingsBarOpen,
      }: {
        isAdvancedSettingsBarOpen: boolean;
      }) => (isAdvancedSettingsBarOpen ? "rotate(180deg)" : "rotate(0)"),

      "&:hover": {
        cursor: "pointer",
      },
    },
    chips: {
      background: theme.primary500,
      color: theme.white50,
      borderRadius: "50px",
      padding: theme.spacing(4, 14),
      fontSize: "14px",
    },
  }),
);
